import PayOverTimeConfirmPayment from 'features/payOverTime/screens/payments/PayOverTimeConfirmPayment/PayOverTimeConfirmPayment';
import React from 'react';

export default function PayOverTimeConfirmPaymentScreen() {
  return <PayOverTimeConfirmPayment />;
}
